export default [
  // 商品买点审核
  {
    path: 'sell-point-audit',
    name: 'SellPointAudit',
    meta: {
      isDynamic: true,
      id: '商品卖点审核', // 6
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "SellPointAudit" */ '@/views/ProductManage/SellPointAudit/SellPointAudit.vue'
      )
  },
  {
    path: 'training-materials-audit',
    name: 'TrainingMaterialsAudit',
    meta: {
      isDynamic: true,
      id: '视频资料审核', // 7
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "TrainingMaterialsAudit" */ '@/views/ProductManage/TrainingMaterialsAudit/TrainingMaterialsAudit.vue'
      )
  },
  {
    path: 'sell-point-and-materials',
    name: 'SellPointAndMaterials',
    meta: {
      isDynamic: true,
      id: '商品卖点和视频资料', // 8
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "SellPointAndMaterials" */ '@/views/ProductManage/SellPointAndMaterials/SellPointAndMaterials.vue'
      )
  },
  {
    path: 'batch-add-sellpoint-and-materials',
    name: 'BatchAddSellPointAndMaterials',
    meta: {
      parentRouteName: 'SellPointAndMaterials'
    },
    component: () =>
      import(
        /* webpackChunkName: "BatchAddSellPointAndMaterials" */ '@/views/ProductManage/BatchAddSellPointAndMaterials/BatchAddSellPointAndMaterials.vue'
      )
  }
];
